import { Component, effect, inject, output, signal } from '@angular/core';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';
import { DistributorService, ProductCategoryService, ProductService } from '@beautyapp/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '@beautyapp/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFormModule } from 'ng-zorro-antd/form';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SelectComponent } from '../../../../../../form/src/lib/select/select.component';

@UntilDestroy()
@Component({
  selector: 'beautyapp-choose-product',
  imports: [
    NzTableModule, TranslateModule, NzSpaceModule, NzIconDirective, NzButtonComponent, FormsModule, InputModule, NzGridModule, NzFormModule, ReactiveFormsModule,
    SelectComponent,
    NgxPermissionsModule
],
  templateUrl: './choose-product.component.html',
  styleUrl: './choose-product.component.scss'
})
export class ChooseProductComponent {
  productService: ProductService = inject(ProductService);
  productCategoryService: ProductCategoryService = inject(ProductCategoryService);
  distributorService: DistributorService = inject(DistributorService);

  productSelected = output<any>();

  distributors = toSignal(this.productCategoryService.dropdown());
  categories = toSignal(this.distributorService.dropdown());

  page = signal(1);
  pageSize = signal(10);
  loading = signal(false);
  distributor = signal<any>(null);
  productCategory = signal<any>(null);
  searchValue = signal<any>(null);
  orderBy = signal('buyDate')
  order = signal<'ASC' | 'DESC'>('ASC')
  total = signal(0);

  services = signal<any[]>([]);



  searchForm = new FormGroup({
    search: new FormControl(null),
    productCategoryId: new FormControl(null),
    distributorId: new FormControl(null),
    branch: new FormControl(null)
  });

  constructor() {
    effect(() => {
      this.getServices(this.page(), this.pageSize(),this.orderBy(), this.order(),  this.searchValue(), this.distributor(), this.productCategory());
    });
  }

  getServices(page: number, pageSize: number, orderBy: string, order: 'ASC' | 'DESC', searchValue?: string, distributorId?: string, productCategoryId?: string) {
    this.loading.set(true);
    this.productService
      .get({
        page,
        pageSize: pageSize,
        orderBy: orderBy,
        order: order,
        search: searchValue,
        productCategoryId: productCategoryId || 'null',
        distributorId: distributorId || 'null'
      })
      .pipe(untilDestroyed(this))
      .subscribe((res) => {
        console.log(res);
        this.loading.set(false);
        this.services.set(res.data);
        this.total.set(res.meta.itemCount);
      });
  }

  paginatorChange(params: any) {
    console.log(params);
    const { pageSize, pageIndex, sort, filter } = params;
    const currentSort = sort.find((item: any) => item.value !== null);
    if (currentSort) {
      this.orderBy.set(currentSort && currentSort.key)
      this.order.set((currentSort && currentSort.value) === 'ascend' ? 'ASC' : 'DESC')
    } else {
      this.orderBy.set('buyDate');
      this.order.set('DESC');
    }
    this.page.set(pageIndex);
    this.pageSize.set(pageSize);
  }

  clearSearch() {
    this.searchValue.set(null);
    this.distributor.set(null);
    this.productCategory.set(null);
    this.page.set(1);

    this.searchForm.setValue({
      search: null,
      productCategoryId: null,
      distributorId: null,
      branch: null
    });
  }

  search() {
    this.page.set(1);
    this.searchValue.set(this.searchForm.value.search || 'undefined');
    this.distributor.set(this.searchForm.value.distributorId || null);
    this.productCategory.set(this.searchForm.value.productCategoryId || null);
  }
}
